import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress the benign "ResizeObserver loop completed with undelivered notifications"
// warning that Radix UI's Select/Popover triggers occasionally. It's a no-op
// notification (the next frame settles correctly) but CRA's dev error overlay
// treats it as a fatal error and blocks dialog interactions. Production builds
// are unaffected — the overlay only renders in development.
const RESIZE_OBSERVER_PATTERNS = [
  "ResizeObserver loop completed with undelivered notifications",
  "ResizeObserver loop limit exceeded",
];
window.addEventListener("error", (event) => {
  if (event?.message && RESIZE_OBSERVER_PATTERNS.some((p) => event.message.includes(p))) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
